import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Container,
  Row,
  Col,
  Button,
  Media,
  Label
} from 'reactstrap';
import Fade from 'react-reveal/Fade';
import ProcessSvg from './img/Process.svg';
import ConcreteSectionStressJpg from './img/ConcreteSectionGeometry.jpg';

const Fonctionnement = ({
	link
}) => {
	return(
		<div className="section"> 
			<Container>
				<Row>
					
					<Col lg={12}>
						<Row>
						<Fade left cascade>
								<Media className="app">
									<Media left href="#">
										<FormattedMessage id="section_alt">
											{
												alt =>  (
													<img
														className="icon" 
														src={ProcessSvg}
														alt={alt} 
													/>
												)
											}
										</FormattedMessage>
									</Media>
									<Media body>
										<Media heading>
											<h2 className="label">
                        Le Fonctionnement    
											</h2>
										</Media>
										<Label className="subTitle">
											Architecture
										</Label>
									</Media>
								</Media>
							</Fade>
						</Row>
						<Row>
							<Fade left>
								<p className="lead">
								  <h3 className="label">La Marketplace et ses applications </h3>

                      <h4 className="label">Un outil varié</h4>



								<p ClassName="lead">
                La Marketplace TriDyme propose diverses applications Web de calcul à destination des bureaux d'études, comme de la modélisation 3D, du calcul de structure,..

 

Elle est directement accessible en ligne, aucune installation n'est requise. De plus, la puissance du cloud permet de réaliser d'importants calculs simultanément, mais également de les stocker sans limite.

</p>

<h3 className="label">Spécifité BIM </h3>

<h4 className="label">La performance du mode Cloud</h4>

									Notre application visionneuse BIM vous permet de travailler en ligne sur vos maquettes BIM. Il vous est également possible de partager ce document avec vos collaborateurs et donc de travailler à plusieurs sur un projet, à distance. Les modifications réalisées seront instantanément appliquées sur l'ensemble des documents ouverts.
                </p>
							</Fade>
							<Fade left cascade>
								<ul className="lead">
									
								</ul>
							</Fade>
						</Row>
						<Row>
              <Col lg={12}>
                <Fade left className>
                  <Button
                    href={link}
                    className="negativeButton"
                  >
                    Essayez
                  </Button>
                </Fade>
              </Col>
						</Row>
					</Col>
          {/* <Col lg={6}>
            <Fade right>
              <div className="imgContainer">
                <img className="imgContent" src={ConcreteSectionStressJpg} alt="Sections" /> 
              </div>
            </Fade>
					</Col> */}
				</Row>
			</Container>    
		</div>       
	);
};

export default Fonctionnement;
